const COMMON_AD_QUERY_PARAMS = [
  'upv',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'gid',
  'type',
];

type AD_VENDOR =
  | 'Facebook'
  | 'Google'
  | 'Bing'
  | 'Tiktok'
  | 'Podsights'
  | 'BlissPointMedia'
  | 'Everflow'
  | 'VWO'
  | 'Test';

const AD_VENDOR_SPECIFIC_QUERY_PARAMS: { [vendor in AD_VENDOR]?: string[] } = {
  Facebook: ['fbclid'],
  Google: ['gclid'],
  Bing: ['msclkid'],
  Everflow: ['oid', 'affid'],
};

export const getAdVendorQueryString = (
  vendor: AD_VENDOR,
  originParams: URLSearchParams
) => {
  const allowedParams: { key: string; value: string }[] = [];

  const adSpecificKeys = Object.keys(AD_VENDOR_SPECIFIC_QUERY_PARAMS).includes(
    vendor
  )
    ? AD_VENDOR_SPECIFIC_QUERY_PARAMS[vendor]
    : [];
  originParams.forEach((value, key) => {
    if (COMMON_AD_QUERY_PARAMS.includes(key.toLowerCase())) {
      allowedParams.push({ key, value });
    } else if (adSpecificKeys.includes(key.toLowerCase())) {
      allowedParams.push({ key, value });
    }
  });

  const finalQueryString = allowedParams.reduce(
    (queryString, { key, value }) => `${queryString}&${key}=${value}`,
    ''
  );

  return finalQueryString;
};
